import React from 'react';
import { connect } from 'react-redux';
import { fetchTravelsLoad } from './actions';
import PropTypes from 'prop-types';
import { Table, Row, Col, Button } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';


class TravelsList extends React.Component{
  static propTypes = {
    onSubmit: PropTypes.func.isRequired
    };
    constructor(props) {
      super(props);
      this.state = {
        urlImg:'',
        errors: null
    }       
};

    componentDidMount() {     
        //console.log('carga la pagina')   
        this.props.fetchTravelsLoad(this.props.match.params.id); 
    };
    
    renderList(){
        const { travels } = this.props;
        if(travels){
            //console.log('tiene viajes')
       return travels.map (travel => {              
            if(travel.id){  
                
                var endDate, endTime, startDate, startTime, totalTimeMin, totalTimeSec, distance, skooterId, balance_Before, balance_After, totalCost = null
                //this.setState({urlImg: this.re})
                if(typeof travel.end === 'undefined')
                { endTime = "No registrado"
                  endDate = "No registrado"
                }else{
                   endDate = travel.end.toDate().toLocaleDateString()
                   endTime = travel.end.toDate().toLocaleTimeString()
                }
                if(typeof travel.start === 'undefined')
                { startTime = "No registrado"
                  startDate = "No registrado"
                }else{
                    startDate = travel.start.toDate().toLocaleDateString()
                    startTime = travel.start.toDate().toLocaleTimeString()
                }
                if(typeof travel.total_time === 'undefined')                
                {totalTimeMin = "No registrado"
                 totalTimeSec = "No registrado"
                }else{
                    totalTimeMin = parseFloat(travel.total_time/60).toFixed(0)
                    totalTimeSec = parseFloat(travel.total_time%60).toFixed(0)
                }
                if(typeof travel.distance === 'undefined')                
                {distance = "No registrado"}else{
                    distance = parseFloat(travel.distance).toFixed(2)
                }
                if(typeof travel.skooter_id === 'undefined')
                {skooterId = "No registrado"}else{
                    skooterId = travel.skooter_id
                }
                if(typeof travel.balanceAfter === 'undefined')
                {balance_After= "No registrado"}else{
                    balance_After = parseFloat(travel.balanceAfter).toFixed(2)
                }
                if(typeof travel.balanceBefore === 'undefined')
                {balance_Before = "No registrado" }else{
                    balance_Before = parseFloat(travel.balanceBefore).toFixed(2)
                }
                if(typeof travel.total_cost  === 'undefined')
                {totalCost = "No registrado"}else{
                    totalCost = parseFloat(travel.total_cost).toFixed(2)
                }                                 
          return (                 
                  <tr key={travel.id}>
                  <td>{startDate} <br></br> {startTime}</td>                                                            
                  <td>{endDate} <br></br> {endTime}</td>
                  <td>{totalTimeMin}min, {totalTimeSec}seg</td> 
                  <td>{skooterId}</td>                                                            
                  <td>{distance}m</td>
                  <td>{balance_Before}</td>
                  <td>{balance_After}</td>
                  <td>{totalCost}</td>
                  <td><Link to={`/travel/${travel.key}`}><Button color="danger"><FontAwesomeIcon className="fas fa-fw" icon={faCamera} width="25" height="25"/></Button></Link></td>
                  </tr> 
              )}   else {
                return true
            }   
          }
      )  
    }       
  };
    
    render() {            
        const { loading, error } = this.props;
        if(loading){
           return (
            <div className="spinner">
                <Spinner animation="border" role="status">
                <span className="sr-only">Cargando datos...</span>
                </Spinner>
            </div>
           )
        }     

        if(error){
            return (
             <div className="spinner">
                 <h3>Ha ocurrido un error intenténtelo de nuevo en unos segundos</h3>
             </div>
            )
         }   
        return (
            this.props.isFetching ? <Spinner/>
             : (<div>
                  <div>
                  <Row>
                      <Col sm="12" md={{ size: 12 }}>
                          <h2 className="text-center">Viajes del Usuario</h2>                                                
                      </Col> 
                  </Row> 
                  </div>             
                  <Table hover className="text-center">
                      <thead>
                          <tr>
                              <th> Inicio de viaje</th>
                              <th>Fin de viaje</th>
                              <th> Tiempo de Viaje</th>
                              <th>Skooter</th>
                              <th>Distancia</th>                          
                              <th>Balance Inicial</th>
                              <th>Balance Final</th>
                              <th>Costo Total</th>
                              <th>Foto</th>
                          </tr>
                      </thead>
                      <tbody>{this.renderList()}</tbody>                    
                  </Table>                  
              </div>)
          );
      }
  }
    


  const mapStateToProps = state => ({
    travels: state.travels.items,
    loading: state.travels.loading,
    error: state.travels.error
  });
/*const mapStateToProps = (state) => {
    try{
   return { travels: Object.values(state.travels)} 
    } catch{
        return {
            users: Object.values(state.users)            
        };
    }
};*/

export default connect(mapStateToProps, { fetchTravelsLoad })(TravelsList);

//<Button color="success"><FontAwesomeIcon class="fas fa-fw" icon={faCamera} width="25" height="25"/></Button>